import * as React from 'react';
import { useSliderContext } from '@cian/slider';

import { OnboardingSwitcher } from '../../../../components/OnboardingSwitcher';
import { IOnboardingPropsWithFn } from '../../types';
import { useIsDesktop } from '@cian/valuation-utils-component';
import { useMobileFilters } from '../../../../hooks/useMobileFilters';

export const OnboardingSwitcherContainer: React.FC<Omit<IOnboardingPropsWithFn, 'trackShowOnboardingModal'>> = ({
  slides,
  isMobile,
  trackClickOnboardingButton,
  trackClickOnboardingBackButton,
  closeOnboardingModal,
  onFinishClick,
}) => {
  const isDesktop = useIsDesktop();
  const { openMobileFiltersModal } = useMobileFilters();

  const actionFinishFn = isDesktop ? onFinishClick : openMobileFiltersModal;

  const { currentSlide, scrollNext, scrollPrev } = useSliderContext();

  const handleNextClick = React.useCallback(() => {
    scrollNext();
    trackClickOnboardingButton(currentSlide + 1);
  }, [scrollNext, trackClickOnboardingButton, currentSlide]);

  const handlePrevClick = React.useCallback(() => {
    scrollPrev();
    trackClickOnboardingBackButton();
  }, [scrollPrev, trackClickOnboardingBackButton]);

  const handleFinishClick = React.useCallback(() => {
    closeOnboardingModal();
    actionFinishFn();
    trackClickOnboardingButton(currentSlide + 1);
  }, [closeOnboardingModal, actionFinishFn, trackClickOnboardingButton, currentSlide]);

  return (
    <OnboardingSwitcher
      hasNextButton={slides[currentSlide].hasNextButton}
      hasPrevButton={slides[currentSlide].hasPrevButton}
      hasFinishButton={slides[currentSlide].hasFinishButton}
      onNextClick={handleNextClick}
      onPrevClick={handlePrevClick}
      onFinishClick={handleFinishClick}
      isMobile={isMobile}
    />
  );
};
